import { jsx as _jsx } from "react/jsx-runtime";
import { CardsTest } from '../../../components/cardsTest/cardsTest';
export const SettingsIntegrationsCardsCustomTestView = ({ cardType, }) => {
    return _jsx(CardsTest, { cardType: cardType });
};
